import { Record } from 'immutable';

interface UserProfileInterface {
  userUuid: string | null;
  name: string | null;
  email: string | null;
}

interface UserProfileStateInterface {
  isBusy: boolean;
  error: object | null;
  user: UserProfileInterface | null;
}

export const initialState: UserProfileStateInterface = {
  isBusy: false,
  error: null,
  user: {
    userUuid: null,
    name: null,
    email: null
  }
};

export default class UserProfileState extends Record(initialState) {
}
